import React from "react"
import { Badge, BadgeProps, styled } from "@mui/material"

type Props = React.HTMLAttributes<HTMLSpanElement> & BadgeProps

const DotComponent = ({ ...restProps }: Props) => {
  return <Dot variant="dot" overlap="circular" {...restProps} />
}

export default DotComponent

const Dot = styled(Badge)`
  margin: 0 10px 0 5px;
`
